"use client";
import NewTweetListener from "@nitro-ape/shared/features/twitter-tracker/listeners/NewTweetListener";
import TwitterHandleStatusListener from "@nitro-ape/shared/features/twitter-tracker/listeners/TwitterHandleStatusListener";
import { translateBrand } from "@/lib/i18n";
import { BrandMessageIds } from "@nitro-ape/shared/lib/brand-config";
import { createFileRoute } from "@tanstack/react-router";
import TwitterTrackerActionsBar from "./-components/TwitterTrackerActionsBar";
import TwitterTrackerContent from "./-components/TwitterTrackerContent";
import { TwitterFeedPausedProvider } from "./-providers/twitter-feed-paused-provider";

export const Route = createFileRoute("/_main/trackers/twitter/")({
  head: () => ({
    meta: [
      {
        title: translateBrand(BrandMessageIds.metaTitleTwitter),
      },
    ],
  }),
  component: TwitterTrackerPage,
});

function TwitterTrackerPage() {
  return (
    <>
      <TwitterHandleStatusListener>
        <NewTweetListener>
          <TwitterFeedPausedProvider>
            <div className="flex min-h-0 flex-1 flex-col gap-1.5">
              <TwitterTrackerActionsBar />
              <TwitterTrackerContent />
            </div>
          </TwitterFeedPausedProvider>
        </NewTweetListener>
      </TwitterHandleStatusListener>
    </>
  );
}
